const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // introduction: state => state.user.introduction,
  // roles: state => state.user.roles,
  enterpriseName: state => state.user.enterpriseName,
  enterpriseType: state => state.user.enterpriseType,
  enterpriseId: state => state.user.enterpriseId,
  logo: state => state.user.logo,
  nickname: state => state.user.nickname,
  portrait: state => state.user.portrait,
  id: state => state.user.id,
  roleName: state => state.user.roleName,
  permission_routes: state => state.user.permission_routes,

  // permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs
}
export default getters
